import * as React from "react";
import { NoEntitiesExist } from "components/common";
import { randomHexString } from "security-app/components/common/helperFunctions";
import { DataTable } from "security-app/components/common";
import { NoEntitiesExistWrapper } from "../shared";
function PortList({ ports }) {
  if (!ports || ports.length === 0) {
    return /* @__PURE__ */ React.createElement(NoEntitiesExistWrapper, null, /* @__PURE__ */ React.createElement(NoEntitiesExist, null, "No ports reported"));
  }
  return /* @__PURE__ */ React.createElement(DataTable, { condensed: true, striped: true, "aria-label": "Ports list" }, /* @__PURE__ */ React.createElement("tbody", null, ports.map(({ port, protocol }) => /* @__PURE__ */ React.createElement(DataTable.Row, { key: randomHexString(12) }, /* @__PURE__ */ React.createElement(DataTable.Item, null, port), /* @__PURE__ */ React.createElement(DataTable.Item, null, "Protocol: ", protocol)))));
}
export default PortList;
